import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";
import { Container } from "reactstrap";

import {
  getReporteMonitoreoDetalle,
  getReporteMonitoreo,
} from "./../../redux/actions/monitoreo-actividad-actions";

import { ModalLoading } from "./../utils/ModalLoading";
import Loading from "./../utils/Loading";

import { getAreasOrganizacionales } from "./../../redux/actions/areas-actions"; //me
import {
  mostrarPoas,
} from "./../../redux/actions/poa-actions";
import { getCriterios } from "../../redux/actions/criterio_evaluacion_actions";
import { api_base, api_basev2 } from "../../config";
import { getData } from "../../utils/api-client";
import {
  evaluacionEsAusenciaDemanda,
  getSemaforoStyle,
  obtenerPuntuacionPorTrimestre,
  poaUsaPuntuacion,
  truncateString,
  VALOR_NO_APLICA_EVALUACION,
  CRITERIO_AUSENCIA_DEMANDA_ID,
  esValorNoAplica,
} from "../../utils/utils";

class ReporteMonitoreo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingState: true,
      listaProductosState: [],
      listaTrimestreState: [],
      listaProductosOriginalState: [],
      detalleProductosPage: [],
      trimestreActualState: 0,
      modal: false,
      mensaje: false,
      activePage: 1,
      totalPages: 0,
      itemPerPage: 3,
      areaSeleccionanda: 0,
      poaSelected: 0,
      criteriosEvaluacion: []
    };
  }

  async componentDidMount() {
    const { poaActivo, user } = this.props;
    this.setState({ poaSelected: poaActivo.poaId, areaSeleccionanda: user.areaOrganizacional.areaOrganizacionalId, trimestre: this.state.trimestreActualState })
    
    let fechatrimestre = new Date();
    let mesTrimestre = fechatrimestre.getMonth() + 1;
    let trimestreActual = Math.ceil(mesTrimestre /3);

    let monitoreo = {
      poaId: poaActivo.poaId,
      areaOrganizacionalId: user.areaOrganizacional.areaOrganizacionalId,
      trimestreActualState: trimestreActual,
    };
    trimestreActual = this.calcularTrimestreActual();
    this.props.getAreasOrganizacionales();//me
    const criteriosEvaluacion = await this.props.getCriterios();
    this.setState({ criteriosEvaluacion });
    this.cargarData(monitoreo, 0, criteriosEvaluacion);
    // this.setState({areaSeleccionanda:this.props.user.areaOrganizacional.areaOrganizacionalId})
    this.props.mostrarPoas();
  }

  validarPaginacion = (page = 1, elementos = 3) => {
    let index = elementos * page - elementos;
    let listaProductos = [];

    for (let i = 0; i < elementos; i++) {
      listaProductos.push(this.state.listaProductosState[index]);
      index++;
    }

    let totalPages = Math.ceil(
      this.state.listaProductosState.length / elementos
    );

    this.setState({
      detalleProductosPage: listaProductos,
      activePage: page,
      totalPages,
      itemPerPage: elementos,
    });
  };
  calcularTrimestreActual = () => {
    let fechaMes = new Date(2023, 11, 1);
    let Mes = fechaMes.getMonth();
    let trimestreTotal = Math.ceil(Mes / 3);
    let listaTrimestre = [];
    for (let i = 1; i <= trimestreTotal; i++) {
      listaTrimestre.push(i);
    }

    let fechatrimestre = new Date();
    let mesTrimestre = fechatrimestre.getMonth() + 1;
    let trimestreActual = Math.ceil(mesTrimestre /3);
    this.setState({
      trimestreActualState: trimestreActual,
      listaTrimestreState: listaTrimestre,
    });

    return trimestreActual;
  };

  cargarData = async (monitoreo, areaFiltro = 0, criteriosEvaluacion = null) => {
    if (areaFiltro > 0) {
      monitoreo.areaOrganizacionalId = areaFiltro;

      this.setState({ areaSeleccionanda: areaFiltro });
    }

    await this.props.getReporteMonitoreoDetalle(monitoreo);
    const { productos } = this.props.reporteMonitoreoDetalle;
    let listaProductosOriginal = productos;
    let listaProductos = listaProductosOriginal;
    const trimestreCarga =
      monitoreo.trimestreActualState || this.state.trimestreActualState;

    listaProductos = await this.actualizarSeguimientoTrimestreProductos(
      listaProductos,
      trimestreCarga
    );

    const poaSeleccionado =
      this.props.poas.find(
        (poa) => Number(poa.poaId) === Number(monitoreo.poaId)
      ) ||
      (Number(this.props.poaActivo.poaId) === Number(monitoreo.poaId)
        ? this.props.poaActivo
        : null);

    if (poaUsaPuntuacion(poaSeleccionado)) {
      listaProductos = await this.cargarPuntuacionesEvaluacion(
        listaProductos,
        trimestreCarga,
        criteriosEvaluacion
      );
    }

    this.setState(
      {
        isLoadingState: false,
        listaProductosState: listaProductos,
        listaProductosOriginalState: listaProductosOriginal,
      },
      () => this.validarPaginacion()
    );
  };

  actualizarSeguimientoTrimestreProductos = (listaProductos, trimestre) => {
    this.setState({
      trimestreActualState: `${trimestre}`
    })


    listaProductos.map((producto) =>
      producto.actividades.map(
        (actividad) =>
          (actividad = this.calcularSeguimientoTrimestre(trimestre, actividad))
      )
    );
    return listaProductos;
  };

  cargarPuntuacionesEvaluacion = async (
    listaProductos,
    trimestre,
    criteriosEvaluacionForzados = null
  ) => {
    const trimestreNormalizado = Number(`${trimestre}`.replace(/\D/g, ""));
    const criteriosEvaluacion =
      criteriosEvaluacionForzados?.length > 0
        ? criteriosEvaluacionForzados
        : this.state.criteriosEvaluacion?.length > 0
        ? this.state.criteriosEvaluacion
        : this.props.criterios;

    const poaIdReporte = this.state.poaSelected || this.props.poaActivo.poaId;
    const areaIdReporte = this.state.areaSeleccionanda;
    const urlMonitoreosAdmin =
      areaIdReporte > 0
        ? `${api_base}api/v1/adminmonitoreosactividad/poaId/${poaIdReporte}/${areaIdReporte}`
        : `${api_base}api/v1/adminmonitoreosactividad/poaId/${poaIdReporte}`;
    const [monitoreosAdminResponse, evaluacionesGlobalResponse] =
      await Promise.all([
        getData.get(urlMonitoreosAdmin).catch(() => ({ data: [] })),
        getData
          .get(`${api_basev2}MonitoreoEvaluaciones/ObtenerMonitoreosEvaluados`)
          .catch(() => ({ data: { data: [] } })),
      ]);
    const monitoreosAdminData =
      monitoreosAdminResponse.data?.value || monitoreosAdminResponse.data || [];
    const monitoreosAdmin = Array.isArray(monitoreosAdminData)
      ? monitoreosAdminData
      : [monitoreosAdminData].filter(Boolean);
    const evaluacionesGlobalData = evaluacionesGlobalResponse.data?.data || [];
    const evaluacionesGlobales = Array.isArray(evaluacionesGlobalData)
      ? evaluacionesGlobalData
      : [evaluacionesGlobalData].filter(Boolean);

    const obtenerEvaluacionesGuardadas = async (monitoreoId) => {
      const evaluacionesGuardadas = evaluacionesGlobales.filter(
        (evaluacion) => Number(evaluacion.monitoreoId) === Number(monitoreoId)
      );

      if (evaluacionesGuardadas.length > 0) return evaluacionesGuardadas;

      const evaluacionesResponse = await getData.get(
        `${api_basev2}MonitoreoEvaluaciones/ObtenerMonitoreoEvaluadoById?monitoreoId=${monitoreoId}`
      );
      const evaluacionesData = evaluacionesResponse.data?.data || [];

      return Array.isArray(evaluacionesData)
        ? evaluacionesData
        : [evaluacionesData].filter(Boolean);
    };

    const productosConPuntuacion = await Promise.all(
      listaProductos.map(async (producto) => {
        if (!Array.isArray(producto.actividades)) return producto;

        const actividades = await Promise.all(
          producto.actividades.map(async (actividad) => {
            try {
              const monitoreosResponse = await getData.get(
                `${api_basev2}Monitoreo/GetByActividadId?actividadId=${actividad.actividadId}`
              );
              const monitoreosData = monitoreosResponse.data?.data || [];
              const monitoreosPorActividad = Array.isArray(monitoreosData)
                ? monitoreosData
                : [monitoreosData].filter(Boolean);
              const monitoreosDesdeAdmin = monitoreosAdmin.filter(
                (monitoreo) =>
                  Number(monitoreo.actividadId) ===
                  Number(actividad.actividadId)
              );
              const monitoreos = [
                ...monitoreosDesdeAdmin,
                ...monitoreosPorActividad,
              ].filter(
                (monitoreo, index, lista) =>
                  monitoreo?.monitoreoId &&
                  lista.findIndex(
                    (item) =>
                      Number(item.monitoreoId) ===
                      Number(monitoreo.monitoreoId)
                  ) === index
              );
              const monitoreosDelTrimestre = monitoreos.filter((item) => {
                const trimestreItem = Number(
                  `${item.trimestre}`.replace(/\D/g, "")
                );

                return trimestreItem === trimestreNormalizado;
              });
              const monitoreosOrdenados = [...monitoreosDelTrimestre].sort(
                (a, b) => {
                  const aprobadoB =
                    Number(b.nivelAprobacionId) === 5 ? 1 : 0;
                  const aprobadoA =
                    Number(a.nivelAprobacionId) === 5 ? 1 : 0;

                  return (
                    aprobadoB - aprobadoA ||
                    Number(b.monitoreoId || 0) - Number(a.monitoreoId || 0)
                  );
                }
              );

              let evaluaciones = [];

              for (const monitoreo of monitoreosOrdenados) {
                if (!monitoreo?.monitoreoId) continue;

                const evaluacionesMonitoreo =
                  await obtenerEvaluacionesGuardadas(monitoreo.monitoreoId);

                if (evaluacionesMonitoreo.length > 0) {
                  evaluaciones = evaluacionesMonitoreo;
                  break;
                }
              }

              if (evaluaciones.length === 0) return actividad;

              const esAusenciaDemanda =
                evaluaciones.some(
                  (evaluacion) =>
                    Number(evaluacion.criterioId) ===
                      CRITERIO_AUSENCIA_DEMANDA_ID &&
                    (esValorNoAplica(evaluacion.resultado) ||
                      Number(evaluacion.resultado) > 0)
                ) ||
                evaluacionEsAusenciaDemanda(
                  evaluaciones,
                  criteriosEvaluacion
                );
              const puntuacion = esAusenciaDemanda
                ? VALOR_NO_APLICA_EVALUACION
                : evaluaciones.reduce(
                    (total, evaluacion) =>
                      total + (Number(evaluacion.resultado) || 0),
                    0
                  );

              return {
                ...actividad,
                evaluaciones: {
                  ...(actividad.evaluaciones || {}),
                  [`t${trimestreNormalizado}`]: puntuacion,
                },
                evaluacionesNoAplica: {
                  ...(actividad.evaluacionesNoAplica || {}),
                  [`t${trimestreNormalizado}`]: esAusenciaDemanda,
                },
              };
            } catch (error) {
              return actividad;
            }
          })
        );

        return { ...producto, actividades };
      })
    );

    return productosConPuntuacion;
  };

  cambiarSeguimientoPorTrimestre = async (e) => {
    let trimestreSelected = e.currentTarget.value;
    this.setState({
      isLoadingState: true,
      trimestreActualState: trimestreSelected,
    });

    const { listaProductosOriginalState } = this.state;
    let listaProductos = this.actualizarSeguimientoTrimestreProductos(
      listaProductosOriginalState,
      trimestreSelected
    );

    const poaSeleccionado =
      this.props.poas.find(
        (poa) => Number(poa.poaId) === Number(this.state.poaSelected)
      ) ||
      (Number(this.props.poaActivo.poaId) === Number(this.state.poaSelected)
        ? this.props.poaActivo
        : null);

    if (poaUsaPuntuacion(poaSeleccionado)) {
      listaProductos = await this.cargarPuntuacionesEvaluacion(
        listaProductos,
        trimestreSelected
      );
    }

    this.setState({
      listaProductosState: listaProductos,
    }, () => this.validarPaginacion(this.state.activePage, this.state.itemPerPage));

    this.setState({
      isLoadingState: false,
    });
  };

  calcularSeguimientoTrimestre = (trimestre, actividad) => {
    let valorTrimestre = 0;
    let valorTrimestreEjecutado = 0;

    for (let i = 1; i <= trimestre; i++) {
      valorTrimestre += parseFloat(actividad[`t${i}`]);
      valorTrimestreEjecutado += parseFloat(actividad[`t${i}e`]);
    }

    if (valorTrimestre == 0) {
      actividad.primerSeguimiento = "";
      actividad.segundoSeguimiento = "";
      actividad.tercerSeguimiento = "";
      return actividad;
    }

    if (valorTrimestreEjecutado > valorTrimestre) {
      let igualarTrimestre = valorTrimestreEjecutado - valorTrimestre;
      valorTrimestreEjecutado = valorTrimestreEjecutado - igualarTrimestre;
    }

    let resultado = parseFloat(
      (valorTrimestreEjecutado / valorTrimestre) * 100
    );

    if (resultado < 50) {
      actividad.primerSeguimiento = resultado;
      actividad.segundoSeguimiento = "";
      actividad.tercerSeguimiento = "";
    } else if (resultado >= 50 && resultado < 100) {
      actividad.primerSeguimiento = "";
      actividad.segundoSeguimiento = resultado;
      actividad.tercerSeguimiento = "";
    } else {
      actividad.primerSeguimiento = "";
      actividad.segundoSeguimiento = "";
      actividad.tercerSeguimiento = resultado;
    }

    return actividad;
  };

  reporteMonitoreo = async () => {
    const areaSeleccionanda = Number(this.state.areaSeleccionanda);
    const poaSelected = Number(this.state.poaSelected);
    let areaOrganizacional = this.props.areaOrganizacionales.find(
      (x) => Number(x.areaOrganizacionalId) === areaSeleccionanda
    );
    let poa = this.props.poas.find(
      (x) => Number(x.poaId) === poaSelected
    );

    if (!areaOrganizacional || !poa) {
      this.setState({
        modal: true,
        mensaje: "No se pudo generar el reporte: falta el área o el POA seleccionado",
      });

      setTimeout(() => {
        this.setState({ modal: false });
      }, 2000);

      return;
    }

    let monitoreo = {
      areaOrganizacionalId: areaOrganizacional.areaOrganizacionalId,
      poaId: poa.poaId,
      areaOrganizacional: areaOrganizacional.nombre,
      ano: poa.ano,
      trimestre: this.state.trimestreActualState
    };
    this.setState({ modal: true, mensaje: "Elaborando Reporte de Monitoreo" });
    const resultado = await this.props.getReporteMonitoreo(monitoreo);

    this.setState({
      mensaje: resultado?.error || resultado?.mensaje || "Reporte descargado",
    });

    setTimeout(() => {
      this.setState({ modal: false });
    }, 1500);
  };

  render() {
    const {
      isLoadingState,
      detalleProductosPage,
      trimestreActualState,
    } = this.state;
    const poaSeleccionado =
      this.props.poas.find(
        (poa) => Number(poa.poaId) === Number(this.state.poaSelected)
      ) ||
      (Number(this.props.poaActivo.poaId) === Number(this.state.poaSelected)
        ? this.props.poaActivo
        : null);
    const usaPuntuacion = poaUsaPuntuacion(poaSeleccionado);
    const anoPoaSeleccionado = poaSeleccionado?.ano || "";

    return (
      <div className="pb-6 pt-5 pt-md-7">
        <Container fluid>
          <div className="container-fluid bg-white border py-3">
            {isLoadingState ? (
              <Loading></Loading>
            ) : detalleProductosPage.length > 0 ? (
              <React.Fragment>
                <div className="row">
                  <div className="col-md-3 my-2">
                    {/*///////////////////////////////////////////*/}
                    <h3>Filtro Área</h3>
                    <select
                      className="form-control"
                      defaultValue={this.state.areaSeleccionanda}
                      id="areaSelected"
                      onChange={(e) => {
                        e.preventDefault();
                        this.setState({ isLoadingState: true });
                        this.setState({ areaSeleccionanda: document.getElementById("areaSelected").value });

                        const { poaActivo, user } = this.props;
                        let monitoreo2 = {
                          poaId: this.state.poaSelected,
                          areaOrganizacionalId: document.getElementById("areaSelected").value,
                        };
                        //alert(monitoreo2.areaOrganizacionalId);
                        this.cargarData(monitoreo2);
                      }}
                    >
                      {this.props.areaOrganizacionales.map((area) => (
                        <option key={area.areaOrganizacionalId} value={area.areaOrganizacionalId}>
                          {area.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* ////////////////////////////////////////// */}

                  <div className="col-md-2 my-2">
                    <h3>Trimestre seleccionado</h3>
                    <select
                      defaultValue={this.state.trimestreActualState}
                      onChange={(e) => {
                        this.cambiarSeguimientoPorTrimestre(e);
                      }}
                      className="form-control"
                    >
                      {this.state.listaTrimestreState.map((trimestre) => (
                        <option key={trimestre}>{trimestre}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2 my-2">
                    <h3>Poa Activo</h3>
                    <select
                      defaultValue={this.state.poaSelected}
                      id="poaSelected"
                      onChange={(e) => {
                        // this.cargarData(this.state.monitoreo,this.state.areaSeleccionanda,e.poaId);

                        e.preventDefault();
                        this.setState({ isLoadingState: true });
                        this.setState({ poaSelected: e.currentTarget.value });

                        const { poaActivo, user } = this.props;
                        let monitoreo2 = {
                          areaOrganizacionalId: this.state.areaSeleccionanda,
                          poaId: e.currentTarget.value
                        };
                        this.cargarData(monitoreo2);
                      }}
                      className="form-control"
                    >
                      {this.props.poas.map((poa) => (
                        <option key={poa.poaId} value={poa.poaId}>{poa.ano}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 my-2 float-right">
                    <div className="col-md-6 ">
                      <h3>Productos por paginas</h3>
                      <select
                        className="form-control"
                        onChange={(e) => {
                          e.preventDefault();
                          this.validarPaginacion(1, e.currentTarget.value);
                        }}
                      >
                        <option key="3" value={3}>
                          3
                        </option>
                        <option key="6" value={6}>
                          6
                        </option>
                        <option key="10" value={10}>
                          10
                        </option>
                        <option key="15" value={15}>
                          15
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-1 mt-5 float-right">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        this.reporteMonitoreo();
                      }}
                      className="btn btn-lg btn-success float-right ml-3"
                    >
                      Reporte Monitoreo
                    </button>
                  </div>
                </div>

                <table
                  className="table table-bordered table-sm "
                  style={{ lineHeight: 1 }}
                >
                  <thead>
                    <tr
                      className="text-center"
                      style={{
                        backgroundColor: "#ee2a24",
                        color: "white",
                      }}
                    >
                      <th style={{ width: "20%" }}>1</th>
                      <th style={{ width: "25%" }}>2</th>
                      <th style={{ width: "15%" }}>3</th>
                      <th style={{ width: "" }} colSpan="4">
                        4
                      </th>
                      <th style={{ width: "" }} colSpan="3">
                        5
                      </th>
                    </tr>
                    <tr
                      className="text-center"
                      style={{
                        backgroundColor: "#003876",
                        color: "white",
                      }}
                    >
                      <th style={{ whiteSpace: "normal" }} rowSpan={2}>
                        Producto (s)
                      </th>
                      <th style={{ whiteSpace: "normal" }} rowSpan={2}>
                        Actividad (es)
                      </th>
                      <th style={{ whiteSpace: "normal" }} rowSpan={2}>
                        Medio Verificación
                      </th>

                      <th
                        rowSpan={1}
                        colSpan="4"
                        style={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                        }}
                      >
                        Nivel de Ejecución <br />
                        <br />
                        Planificado / Ejecutado
                        <br />
                        <table width="100%">
                          <thead>
                            <tr>
                              <th>E-M</th>
                              <th>A-J</th>
                              <th>J-S</th>
                              <th>O-D</th>
                            </tr>
                          </thead>
                        </table>
                      </th>
                      {
                         usaPuntuacion ? 
                         <th style={{ whiteSpace: "normal" }}>Puntuación</th> 
                         : 
                         <th
                        rowSpan={1}
                        colSpan="3"
                        style={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                        }}
                      >
                        Seguimiento al trimestre
                        <table width="100%">
                          <thead>
                            <tr>
                              <th>0-49%</th>
                              <th>50-99%</th>
                              <th> 100%</th>
                            </tr>
                          </thead>
                        </table>
                      </th>
                      }
                      
                    </tr>
                  </thead>
                  <tbody>
                    {detalleProductosPage.map(
                      (producto) =>
                        producto !== null &&
                        producto !== undefined && (
                          <tr key={producto.producto}>
                            <td
                              rowSpan={producto.colspan}
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "inherit",
                              }}
                              title={producto.producto.trim()}
                            >
                              {producto.producto.trim()}
                            </td>
                            <td
                              rowSpan={producto.colspan}
                              style={{ padding: 0 }}
                            >
                              <table width="100%">
                                <tbody>
                                  {producto.actividades.map((actividad) => (
                                    <tr key={actividad.actividadId}>
                                      <td
                                        title={actividad.actividad}
                                        style={{
                                          whiteSpace: "normal",
                                          height: 100,
                                          verticalAlign: "inherit",
                                        }}
                                      >
                                        {actividad.actividad}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                            <td
                              rowSpan={producto.colspan}
                              style={{ padding: 0 }}
                            >
                              <table style={{ tableLayout: "fixed" }}>
                                <tbody>
                                  {producto.actividades.map((actividad) => (
                                    <tr key={actividad.actividadId}>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                          height: 100,
                                          width: "100%",
                                          verticalAlign: "inherit",
                                          textAlign: "center",
                                        }}
                                      >
                                        {truncateString(
                                          actividad.medioVerificacion,
                                          57
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>

                            <td
                              rowSpan={producto.colspan}
                              colSpan="4"
                              style={{ padding: 0 }}
                            >
                              <table width="100%">
                                <tbody>
                                  {producto.actividades.map((actividad) => (
                                    <tr key={actividad.actividadId}>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                          height: 100,
                                          width: 45,
                                          verticalAlign: "inherit",
                                          textAlign: "center",
                                        }}
                                      >
                                        {actividad.t1} / {actividad.t1e}
                                      </td>
                                      <td
                                        style={
                                          trimestreActualState < 2
                                            ? {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                                backgroundColor: "#ddd6",
                                                cursor: "not-allowed",
                                              }
                                            : {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                              }
                                        }
                                      >
                                        {actividad.t2} /{" "}
                                        {trimestreActualState < 2
                                          ? "-"
                                          : actividad.t2e}
                                      </td>
                                      <td
                                        style={
                                          trimestreActualState < 3
                                            ? {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                                backgroundColor: "#ddd6",
                                                cursor: "not-allowed",
                                              }
                                            : {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                              }
                                        }
                                      >
                                        {actividad.t3} /{" "}
                                        {trimestreActualState < 3
                                          ? "-"
                                          : actividad.t3e}
                                      </td>
                                      <td
                                        style={
                                          trimestreActualState < 4
                                            ? {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                                backgroundColor: "#ddd6",
                                                cursor: "not-allowed",
                                              }
                                            : {
                                                whiteSpace: "normal",
                                                height: 100,
                                                width: 45,
                                                verticalAlign: "inherit",
                                                textAlign: "center",
                                              }
                                        }
                                      >
                                        {actividad.t4} /{" "}
                                        {trimestreActualState < 4
                                          ? "-"
                                          : actividad.t4e}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                            {/* Mantener funcionalidad para anos anteriores al 2026, solo usar esta implementacion para 2026+ */}
                            {usaPuntuacion ? (
                            <td rowSpan={producto.colspan} style={{ padding: 0 }}>
                              <table width="100%" style={{ borderCollapse: "collapse", borderSpacing: 0, height: "100%" }}>
                                <tbody>
                                {producto.actividades.map((actividad) => {
                                  const puntuacionTrimestre = obtenerPuntuacionPorTrimestre(
                                    actividad.evaluaciones ||
                                      actividad.monitoreoEvaluaciones ||
                                      actividad.evaluacion,
                                    this.state.trimestreActualState
                                  );

                                  const evaluacionesActividad =
                                    actividad.monitoreoEvaluaciones ||
                                    actividad.evaluacionesDetalle ||
                                    actividad.evaluacionDetalle ||
                                    [];
                                  const evaluacionesActividadLista =
                                    Array.isArray(evaluacionesActividad)
                                      ? evaluacionesActividad
                                      : [evaluacionesActividad].filter(Boolean);
                                  const esNoAplica =
                                    actividad.evaluacionesNoAplica?.[
                                      `t${this.state.trimestreActualState}`
                                    ] ||
                                    esValorNoAplica(puntuacionTrimestre) ||
                                    evaluacionesActividadLista.some(
                                      (evaluacion) =>
                                        Number(evaluacion.criterioId) ===
                                          CRITERIO_AUSENCIA_DEMANDA_ID &&
                                        (esValorNoAplica(evaluacion.resultado) ||
                                          Number(evaluacion.resultado) > 0)
                                    );
                                  const tienePuntuacion =
                                    esNoAplica ||
                                    (puntuacionTrimestre !== null &&
                                      puntuacionTrimestre !== undefined);

                                  return (
                                    <tr key={actividad.actividadId} style={{ height: 100 }}>
                                      <td
                                        style={{
                                          height: 100,
                                          width: "100%",
                                          padding: 0,
                                          ...(tienePuntuacion
                                            ? getSemaforoStyle(
                                                esNoAplica
                                                  ? null
                                                  : puntuacionTrimestre
                                              )
                                            : {}),
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            fontWeight: "900",
                                            color: tienePuntuacion ? undefined : "black",
                                          }}
                                        >
                                          {esNoAplica
                                            ? "N/A"
                                            : tienePuntuacion
                                            ? `${puntuacionTrimestre}%`
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                                </tbody>
                              </table>
                            </td> )
                          :
                          <td
                          rowSpan={producto.colspan}
                          style={{ padding: 0 }}
                        >
                          <table width="100%">
                            <tbody>
                              {producto.actividades.map((actividad) => (
                                <tr key={actividad.actividadId}>
                                  <td
                                    style={{
                                      height: 100,
                                      width: 50,
                                      backgroundColor:
                                        actividad.primerSeguimiento !== ""
                                          ? "#C00000"
                                          : "white",
                                      color: "white",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    {actividad.primerSeguimiento !== "" &&
                                      Math.round(
                                        (actividad.primerSeguimiento + Number.EPSILON) * 100
                                      ) /
                                        100 +
                                        "%"}
                                  </td>
                        
                                  <td
                                    style={{
                                      height: 100,
                                      width: 50,
                                      backgroundColor:
                                        actividad.segundoSeguimiento !== ""
                                          ? "#FFFF00"
                                          : "white",
                                      color: "#666",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    {actividad.segundoSeguimiento !== "" &&
                                      Math.round(
                                        (actividad.segundoSeguimiento + Number.EPSILON) * 100
                                      ) /
                                        100 +
                                        "%"}
                                  </td>
                        
                                  <td
                                    style={{
                                      height: 100,
                                      width: 50,
                                      backgroundColor:
                                        actividad.tercerSeguimiento !== ""
                                          ? "#009900"
                                          : "white",
                                      color: "white",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    {actividad.tercerSeguimiento !== "" &&
                                      Math.round(
                                        (actividad.tercerSeguimiento + Number.EPSILON) * 100
                                      ) /
                                        100 +
                                        "%"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>}
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
                <ModalLoading
                  modal={this.state.modal}
                  mensaje={this.state.mensaje}
                ></ModalLoading>
                <div className="d-flex justify-content-center">
                  <Pagination
                    prevPageText="ant"
                    nextPageText="sig"
                    firstPageText="prime"
                    lastPageText="ultimo"
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={this.state.activePage}
                    itemsCountPerPage={Number(this.state.itemPerPage)}
                    totalItemsCount={this.state.listaProductosState.length}
                    //pageRangeDisplayed={5}
                    onChange={this.validarPaginacion.bind(this)}
                  />
                </div>
              </React.Fragment>
            ) : (
              <h3 className="text-center">
                No tiene productos agregados en el POA {this.state.ano}{" "}
              </h3>
            )}
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  poaActivo: state.poas.poaActivo,
  poas: state.poas.poas,
  user: state.auth.signed,
  reporteMonitoreoDetalle: state.monitoreosActividad.reporteMonitoreoDetalle,
  areaOrganizacionales: state.areasOrganizacionales.areasOrganizacionales,//me
  monitoreoEvaluaciones: state.monitoreoEvaluaciones.monitoreoEvaluaciones,
  criterios: state.criterios.criterios,
});

const mapDispatchToProps = (dispatch) => ({
  getReporteMonitoreoDetalle: (monitoreo) =>
    dispatch(getReporteMonitoreoDetalle(monitoreo)),
  getReporteMonitoreo: (monitoreo) => dispatch(getReporteMonitoreo(monitoreo)),
  getAreasOrganizacionales: () => dispatch(getAreasOrganizacionales()),//me
  mostrarPoas: () => dispatch(mostrarPoas()),
  getCriterios: () => dispatch(getCriterios()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReporteMonitoreo);
